<template>
  <div class="core">
        <div class="layui-fluid">
            <div>
                <div class="layui-form layui-card-header layuiadmin-card-header-auto">
                    <div class="layui-form-item">
                        <div class="layui-inline">
                            字典名称
                        </div>
                        <div class="layui-inline">
                            <input class="layui-input"  autocomplete="off"  placeholder="请输入字典名称" v-model="t_dic.queryObject['DIC_NAME:2']">
                        </div>
                        <div class="layui-inline">
                            字典域标签
                        </div>
                        <div class="layui-inline">
                            <input class="layui-input"  autocomplete="off"  placeholder="请输入字典域" v-model="t_dic.queryObject['DIC_CATEGORY:2']">
                        </div>
                       <div class="layui-inline">
                            <button class="layui-btn layuiadmin-btn-list" @click="$refs.t_dic.search()" title="查询">查询</button>
                            <button class="layui-btn" @click="$refs.t_dic.reset()" title="重置">重置</button>
                        </div>
                    </div>
                </div>
                <div class="layui-card-body">
                    <div class="ywpt-btn">
                        <button class="layui-btn layuiadmin-btn-role"
                            @click="$refs.dictForm.open('添加根节点', 600);
                            $refs.dictForm.setDefaultValue('JB',1).setDefaultValue('DIC_PCODE', -1).setDefaultValue('PARENT_DIC', null);;
                            $refs.dictForm.setEditRow();">
                            添加
                        </button>
                    </div>
                    <div class="layui-table-body layui-table-main">
                        <layui-tabletree
                            ref="t_dic"
                            :expand-level = "1"
                            table-name="DB_DICTIONARY"
                            show-field="DIC_NAME"
                            treeid = "ID"
                            treepid = "DIC_PCODE"
                            jb-field="JB"
                            :default-condition="{'JB': '1'}"
                            :sort="['I_ORDER:ASC']"
                            :page-size="15"
                            :page-range="6"
                            :page-options="[15, 25, 50, 100]"
                            @tabletree-event-addchild="addchild($event.data)"
                            @tabletree-event-treeedit="treeEdit($event.data)"
                            @tabletree-event-treedel="treeDel($event.data)"
                            height="full-270">
                            <div>
                                <div field="DIC_NAME" title="字典名称" align="center"></div>
                                <div field="DIC_CODE" title="字典代码" align="center"></div>
                                <div field="DIC_CATEGORY" title="字典域" align="center"></div>
                                <div field="JB" title="级别" align="center" width="80"></div>
                                <div field="_opt" align="center" title="操作" width="180">
                                    <script type="text/html">
                                        <a class="layui-btn-xs" lay-event="addchild">新增下级</a>
                                        <a class="layui-btn-xs"  lay-event="treeedit">编辑</a>
                                        <a class="layui-btn-xs-danger" lay-event="treedel">删除</a>
                                    </script>
                                </div>
                            </div>
                        </layui-tabletree>
                    </div>
                </div>
            </div>
        </div>
        <layui-form :rule="form_rule" ref="dictForm" :after-save = "treeAfterSave">
                <template slot-scope="{scope}">
                    <div class="layui-form"  style="padding: 20px 30px 0 0;">
                         <div class="layui-form-item" v-if="scope.editRow.PARENT_DIC">
                            <label class="layui-form-label">上级字典：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.PARENT_DIC"  autocomplete="off" class="layui-input" disabled="disabled">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>字典名称：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.DIC_NAME"  autocomplete="off" class="layui-input" name="DIC_NAME">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"><span class="x-red">*</span>字典代码：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.DIC_CODE"  autocomplete="off" class="layui-input" name="DIC_CODE">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>字典域：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.DIC_CATEGORY"  autocomplete="off" class="layui-input" name="DIC_CATEGORY">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>级别：</label>
                            <div class="layui-input-inline">
                                <label style="line-height: 30px;" v-text="scope.editRow.JB"></label>
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label for="L_repass" class="layui-form-label"> </label>
                            <button class="layui-btn" @click="$refs.dictForm.callableSave($refs.t_dic)">保存</button>
                            <button class="layui-btn" @click="$refs.dictForm.close()">关闭</button>
                        </div>
                    </div>
                </template>
            </layui-form>
    </div>
</template>

<script>
export default {
  name: 'Auth',
  data () {
    return {
       t_dic : {
            queryObject: {}
        },
        form_rule: {
        DIC_NAME: {
          required: { message: '字典名称不能为空' }
        },
        DIC_CODE: {
          required: { message: '字典代码不能为空' }
        },
        DIC_CATEGORY: {
          required: { message: '字典域不能为空' }
        },
      },
    }
  },
  mounted() {
       this.t_dic = this.$refs.t_dic;
  },
  methods: {
      treeAfterSave(row, isNew) {
          var t_dic = this.$refs.t_dic;
          var dictForm = this.$refs.dictForm;
          var treeObjData = t_dic.getTableTreeObj().getTableTreeData();
          dictForm.close();
          if(row[t_dic.jbField] == 1) {
              //根节点
              if (isNew) {
                 // 新增
                 t_dic.data.push(row);
                 treeObjData.push(row);
              } else {
                 // 编辑
                for(var i = 0 ; i < t_dic.data.length ; i++) {
                    var item =  t_dic.data[i];
                    if(item[t_dic.treeid] == row[t_dic.treeid]) {
                        t_dic.data[i] = row;
                        treeObjData[i] = row;
                        break;
                    }
                }
              }

          } else {
            // 处理非根节点
                var parent = [];
                t_dic.findNodeById(row[t_dic.treepid], t_dic.data, parent);
                var parent = parent[0];
                if(! parent.treeList )  parent.treeList  = [];
                if(isNew) {
                    // 新增
                    parent.treeList.push(row);
                } else {
                    // 编辑
                    for(var i = 0 ; i < parent.treeList.length ; i++) {
                        var item = parent.treeList[i];
                        if(item[t_dic.treeid] == row[t_dic.treeid]) {
                            parent.treeList[i] = row;
                            break;
                        }
                    }
                }

              row._p = true;
          }
           t_dic.getTableTreeObj().refresh();
      },
      addchild(row) {
          var t_dic = this.$refs.t_dic;
          this.$refs.dictForm.open('添加下级节点', 600, 500);
          var parentJb = row[t_dic.jbField];
          this.$refs.dictForm.setDefaultValue('JB', Number(parentJb) + 1);
          this.$refs.dictForm.setDefaultValue('PARENT_DIC', row.DIC_NAME);
          this.$refs.dictForm.setDefaultValue('DIC_CATEGORY', row.DIC_CATEGORY);
          this.$refs.dictForm.setDefaultValue('DIC_PCODE', row.ID);
          this.$refs.dictForm.setEditRow();
      },
      treeEdit(row) {
           this.$refs.dictForm.open('编辑当前节点', 600, 500);
           this.$refs.dictForm.setEditRow(row);
      },
      treeDel(row) {
        var t_dic = this.$refs.t_dic;
        var p2 = {};
        var pid = row[t_dic.treeid];
        p2[t_dic.treepid] = pid;
        this.api.queryList(t_dic.tableName, {p2: p2,  p9: t_dic.selectFields, p10: t_dic.sort}).then(response => {
            var result = response.result;
            if(result.length == 0){
                this.layer.openConfirm('<span style="color:red">确定要删除该节点吗?</span>', ()=> {
                    this.api.delRows(t_dic.tableName, { p5: [row]}).then(response => {
                        t_dic.getTableTreeObj().delTreeNode(pid);
                        this.layer.openSuccess('删除成功!');
                    });
                });
            } else {
                this.layer.openAlert('该节点还有子节点，不能删除！', false);
            }
        });
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/dict/Dict.vue